import PageTitle from "../layouts/pageTitle/pageTitle";
import PageHeader from "../layouts/pageHeader/pageHeader";
import { useState, useEffect, useRef } from "react";
import InputSelect from "../layouts/inputField/inputSelect/inputSelect";
import "./crfLibrary.css";
import InputText from "../layouts/inputField/inputText/inputText";
import { getInput } from "../../api/inputApi";
import Spinner from "../layouts/spinner/spinner";
import ResultsTable from "../resultsTable/resultsTable";
import { getSearchResult } from "../../api/searchApi";

const defaultFormData = {
  disease: "SCKLCELL",
  subDisease: "SCKLCELL",
  domain: "",
  subDomain: "",
  copyright: "",
  keyword: "",
};

// Fetch input data once and store it in state
const fetchData = async () => {
  const diseaseInput = await getInput("disease");
  const subDiseaseInput = await getInput("subDisease");
  const domainInput = await getInput("domain");
  const subDomainInput = await getInput("subDomain");
  return { diseaseInput, subDiseaseInput, domainInput, subDomainInput };
};

export default function CrfLibrary() {
  const [formData, setFormData] = useState({ ...defaultFormData });
  const [inputs, setInputs] = useState({
    diseaseInput: [],
    subDiseaseInput: [],
    domainInput: [],
    subDomainInput: [],
  });
  const [dropdowns, setDropdowns] = useState({
    diseasesDrpDwn: [],
    subDiseasesDrpDwn: [],
    domainsDrpDwn: [],
    subDomainsDrpDwn: [],
  });

  const [disableSubDisease, setDisableSubDisease] = useState(true);
  const [disableSubDomain, setDisableSubDomain] = useState(true);

  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState(null);

  const spamBotRef = useRef(null);

  useEffect(() => {
    fetchData().then((data) => {
      setInputs(data);
      setDropdowns({
        diseasesDrpDwn: data.diseaseInput,
        subDiseasesDrpDwn: data.subDiseaseInput,
        domainsDrpDwn: data.domainInput,
        subDomainsDrpDwn: data.subDomainInput,
      });
    });
  }, []);

  let filteredSubDiseases = [];
  let filteredSubDomains = [];

  const handleChange = (e, type) => {
    const value = e.target.value;
    setFormData({ ...formData, [type]: value });

    switch (type) {
      case "disease":
        if (value === "") {
          setDisableSubDisease(true);
          filteredSubDiseases = inputs.subDiseaseInput;
          setFormData({
            ...formData,
            disease: defaultFormData.disease,
            subDisease: defaultFormData.subDisease,
          });
        } else {
          filteredSubDiseases = inputs.subDiseaseInput.filter(
            (subDisease) => subDisease.diseaseId === value
          );

          setDisableSubDisease(false);
        }
        setDropdowns({
          ...dropdowns,
          subDiseasesDrpDwn: filteredSubDiseases,
        });
        break;
      case "domain":
        if (value === "") {
          setDisableSubDomain(true);
          filteredSubDomains = inputs.subDomainInput;
          setFormData({
            ...formData,
            domain: defaultFormData.domain,
            subDomain: defaultFormData.subDomain,
          });
        } else {
          filteredSubDomains = inputs.subDomainInput.filter(
            (subDomain) => subDomain.domainId === value
          );
          setDisableSubDomain(false);
        }

        setDropdowns({
          ...dropdowns,
          subDomainsDrpDwn: filteredSubDomains,
        });
        break;
      default:
        break;
    }
  };

  //console.log(formData);

  const buttonSearchHandler = async (e) => {
    e.preventDefault();
    if (spamBotRef.current && spamBotRef.current.checked) {
      setIsSearching(true);
      setSearchResults(null);

      const searchResult = await getSearchResult("CrfCatalog", formData);
      setSearchResults(searchResult);
      setIsSearching(false);
    } else {
      alert("Warning: Please confirm you are not a spam bot.");
    }
  };

  const buttonClearHandler = (e) => {
    setFormData({ ...defaultFormData });
    setDropdowns({
      ...dropdowns,
      //subDiseasesDrpDwn: [],
      subDomainsDrpDwn: [],
    });
    //setDisableSubDisease(true);
    setDisableSubDomain(true);
    setSearchResults(null);
    setIsSearching(false);
  };

  return (
    <>
      <div className="innerdatatools">
        <PageTitle>CRF Library</PageTitle>
        <PageHeader>
          View and download available CureSCi CRFs using filters below. For best
          results, clear form between searches.
        </PageHeader>

        <div className="view-filters">
          <form id="views-exposed-form-crf-library-page">
            <InputSelect
              id="disease"
              labelText="Disease"
              changeHandler={(e) => handleChange(e, "disease")}
              inputArr={dropdowns.diseasesDrpDwn}
              selectedValue={formData.disease}
              defaultVal="true"
            />
            <InputSelect
              id="subDisease"
              labelText="Sub-Disease"
              changeHandler={(e) =>
                setFormData({ ...formData, subDisease: e.target.value })
              }
              inputArr={dropdowns.subDiseasesDrpDwn}
              //disableVal={disableSubDisease}
              selectedValue={formData.subDisease}
              defaultVal="true"
            />
            <InputSelect
              id="domain"
              labelText="Domain"
              changeHandler={(e) => handleChange(e, "domain")}
              inputArr={dropdowns.domainsDrpDwn}
              selectedValue={formData.domain}
            />
            <InputSelect
              id="subDomain"
              labelText="Sub-Domain"
              changeHandler={(e) =>
                setFormData({ ...formData, subDomain: e.target.value })
              }
              inputArr={dropdowns.subDomainsDrpDwn}
              disableVal={disableSubDomain}
              selectedValue={formData.subDomain}
            />
            <InputSelect
              id="copyright"
              labelText="Copyright"
              changeHandler={(e) =>
                setFormData({ ...formData, copyright: e.target.value })
              }
              inputArr={["True", "False"]}
            />
            <InputText
              id="keyword"
              labelText="Keyword"
              inputValue={formData.keyword}
              changeHandler={(e) =>
                setFormData({ ...formData, keyword: e.target.value })
              }
            />
            {/* <InputSelect
              id="showing"
              labelText="Showing"
              changeHandler={(e) =>
                setFormData({ ...formData, showing: e.target.value })
              }
              inputArr={["25", "50", "100", "All"]}
              defaultVal="25"
            /> */}

            <div className="buttonsection">
              <button
                type="submit"
                id="submit"
                value="Search"
                className="btn btn-primary"
                onClick={(e) => buttonSearchHandler(e)}
              >
                Search
              </button>

              <button
                className="btn btn-primary"
                type="reset"
                id="clear"
                value="clear"
                onClick={(e) => buttonClearHandler(e)}
              >
                Clear
              </button>
            </div>
            <div className="spamBot">
              <label>
                <input
                  type="checkbox"
                  name="not_a_robot"
                  value="1"
                  className="form-checkbox"
                  ref={spamBotRef}
                ></input>
                I am not a spam bot.
              </label>
            </div>
          </form>
          <hr />
        </div>
      </div>
      <div className="innertablediv">
        {isSearching && <Spinner />}
        {searchResults && (
          <ResultsTable data={searchResults} reportType="CRF" />
        )}
      </div>
    </>
  );
}
